export default {"src":"/_next/static/media/duets-icon.5e122494.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};